import LocalizedStrings from 'localized-strings';

import { TransactionPaymentMethod, TransactionStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    accounting: {
      label: 'Proof',
      withoutReceipts: 'No receipt',
    },
    amounts: {
      currencySign: '€',
      greaterThanPlaceholder: 'From 0',
      label: 'Amount',
      lesserThanPlaceholder: '1 000 000',
      to: 'to',
    },
    dates: {
      afterDatePlaceholder: 'dd/mm/aaaa',
      beforeDatePlaceholder: 'dd/mm/aaaa',
      label: 'Date',
      to: 'to',
    },
    errors: {
      amounts: 'The first amount must be lower than the second.',
    },
    operations: {
      label: 'Transaction',
      payin: 'Inbound',
      payout: 'Outbound',
    },
    paymentMethod: {
      label: 'Type',
      placeholder: 'Select',
      [TransactionPaymentMethod.Card]: 'Card',
      [TransactionPaymentMethod.CashDeposit]: 'Cash',
      [TransactionPaymentMethod.Check]: 'Check',
      [TransactionPaymentMethod.DirectDebit]: 'Direct debit',
      [TransactionPaymentMethod.InstantTransfer]: 'Instant transfer',
      [TransactionPaymentMethod.IntraCompanyFundsTransfer]: 'Internal transfer',
      [TransactionPaymentMethod.SwiftTransfer]: 'International transfer',
      [TransactionPaymentMethod.InternationalTransfer]:
        'International transfer',
      [TransactionPaymentMethod.Transfer]: 'Standard transfer',
      [TransactionPaymentMethod.WalletTransfer]: 'Other operations',
    },
    resetFilters: 'Clear',
    status: {
      label: 'Status',
      placeholder: 'Select',
      [TransactionStatus.Canceled]: 'Canceled',
      [TransactionStatus.Pending]: 'Pending',
      [TransactionStatus.Validated]: 'Validated',
    },
    totalCountPlural: '{0} results found',
    totalCountSingular: '{0} result found',
  },
  fr: {
    accounting: {
      label: 'Justificatif',
      withoutReceipts: 'Sans reçu',
    },
    amounts: {
      currencySign: '€',
      greaterThanPlaceholder: 'De 0',
      label: 'Montant',
      lesserThanPlaceholder: '1 000 000',
      to: 'à',
    },
    dates: {
      afterDatePlaceholder: 'jj/mm/aaaa',
      beforeDatePlaceholder: 'jj/mm/aaaa',
      label: 'Date',
      to: 'au',
    },
    errors: {
      amounts: 'Le premier montant doit être inférieur au second.',
    },
    operations: {
      label: 'Transaction',
      payin: 'Entrante',
      payout: 'Sortante',
    },
    paymentMethod: {
      label: 'Type(s)',
      placeholder: 'Sélectionner',
      [TransactionPaymentMethod.Card]: 'Carte',
      [TransactionPaymentMethod.CashDeposit]: 'Espèces',
      [TransactionPaymentMethod.Check]: 'Chèque',
      [TransactionPaymentMethod.DirectDebit]: 'Prélèvement',
      [TransactionPaymentMethod.InstantTransfer]: 'Virement instantané',
      [TransactionPaymentMethod.IntraCompanyFundsTransfer]: 'Virement interne',
      [TransactionPaymentMethod.SwiftTransfer]: 'Virement international',
      [TransactionPaymentMethod.InternationalTransfer]:
        'Virement international',
      [TransactionPaymentMethod.Transfer]: 'Virement standard',
      [TransactionPaymentMethod.WalletTransfer]: 'Autres opérations',
    },
    resetFilters: 'Effacer les filtres',
    status: {
      label: 'État(s)',
      placeholder: 'Sélectionner',
      [TransactionStatus.Canceled]: 'Annulée',
      [TransactionStatus.Pending]: 'En attente',
      [TransactionStatus.Validated]: 'Validée',
    },
    totalCountPlural: '{0} résultats trouvés',
    totalCountSingular: '{0} résultat trouvé',
  },
} as const);

export default locales;
